// src/components/ui/use-toast.js
import { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProviderWrapper({ children }) {
  const [messages, setMessages] = useState([]);

  const toast = ({ title, description }) => {
    const id = Date.now();
    setMessages((msgs) => [...msgs, { id, title, description }]);
    setTimeout(() => {
      setMessages((msgs) => msgs.filter((m) => m.id !== id));
    }, 3000);
  };

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <div className="fixed bottom-4 right-4 space-y-2 z-[100]">
        {messages.map((m) => (
          <div
            key={m.id}
            className="bg-gray-900 text-white px-4 py-2 rounded shadow-lg animate-fade-in"
          >
            <strong>{m.title}</strong>
            <p className="text-sm">{m.description}</p>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}


